<template>
  <div class="column is-12">
    <div class="columns">
      <div class="column is-12">
        <div class="content">
          <h3>{{ $t('settings.generalRules.headline') }}</h3>
          <p>{{ $t('settings.generalRules.copy') }}</p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="columns">
          <div class="column is-6">
            <label for="accommodation_arrival_from" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.accommodationArrivalFrom')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="accommodation_arrival_from" class="edit-box__inline-input is-inline is-time"
                        v-model="sp.value.accommodation_arrival_from" :options="{ inputtype: 'time' }"
                        :error="sp.formErrors.accommodation_arrival_from">
            </form-input>
            <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="accommodation_departure_until" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.accommodationDepartureUntil')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="accommodation_departure_until" class="edit-box__inline-input is-inline is-time"
                        v-model="sp.value.accommodation_departure_until" :options="{ inputtype: 'time' }"
                        :error="sp.formErrors.accommodation_departure_until">
            </form-input>
            <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="arrival_from" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.arrivalFrom')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="arrival_from" class="edit-box__inline-input is-inline is-time"
                        v-model="sp.value.arrival_from" :options="{ inputtype: 'time' }"
                        :error="sp.formErrors.arrival_from">
            </form-input>
            <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="departure_until" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.departureUntil')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="departure_until" class="edit-box__inline-input is-inline is-time"
                        v-model="sp.value.departure_until" :options="{ inputtype: 'time' }"
                        :error="sp.formErrors.departure_until">
            </form-input>
            <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="book_same_day_until" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.bookSameDayUntil')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="book_same_day_until" class="edit-box__inline-input is-inline is-time"
                        v-model="sp.value.book_same_day_until" :options="{ inputtype: 'time' }"
                        :error="sp.formErrors.book_same_day_until">
            </form-input>
            <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="book_same_day_accommodation_until" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.bookSameDayAccommodationUntil')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="book_same_day_accommodation_until" class="edit-box__inline-input is-inline is-time"
                        v-model="sp.value.book_same_day_accommodation_until" :options="{ inputtype: 'time' }"
                        :error="sp.formErrors.book_same_day_accommodation_until">
            </form-input>
            <span class="edit-box__includes-inline-input is-inline-block">Uhr</span>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="minimum_age_for_main_guest" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.minAgeForBooking')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input id="minimum_age_for_main_guest" class="edit-box__inline-input is-inline"
                        v-model="minAgeStr" :options="{ inputtype: 'integer', min: 0, max: 9918 }"
                        :error="sp.formErrors.minimum_age_for_main_guest">
            </form-input>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <label for="toc_url" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.toc')
              }}</label>
          </div>
          <div class="column is-6 text-with-input">
            <form-input
              id="toc_url"
              v-model="sp.value.toc_url"
              class="settings__input"
              :error="sp.formErrors.toc_url"
              placeholder="https://"
              :options="{ inputtype: 'url' }"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <label for="privacy_policy_url" class="label edit-box__includes-inline-input">{{
                $t('settings.generalRules.privacyPolicy')
              }}</label>
          </div>
          <div class="column is-8 text-with-input">
            <form-input
              id="privacy_policy_url"
              v-model="sp.value.privacy_policy_url"
              class="settings__input"
              :error="sp.formErrors.privacy_policy_url"
              placeholder="https://"
              :options="{ inputtype: 'url' }"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-12">
        <div class="content mt-5">
          <h3>{{ $t('settings.additionalRules.headline') }}</h3>
          <p v-html="$t('settings.additionalRules.copy') "></p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="is-clearfix">
          <wysiwyg v-model="sp.value.additional_rules" :options="sp.wysiwygOptions" />
        </div>
      </div>
    </div>
  </div >
</template>

<script>
    import { FormInput, Wysiwyg } from '../../index';

    export default {
        name: 'RulesTab',
        inject: ['settingsParent'],
        components: { FormInput, Wysiwyg },
        data() {
            return {
                wysiwygOptions: {
                    maxChars: 600,
                    placeholder: this.$t('settings.additionalRules.placeholder'),
                },
            };
        },
        computed: {
            sp() { return this.settingsParent; },
            // Proxy as string to satisfy FormInput's String expectation, store as number
            minAgeStr: {
                get() {
                    const v = this.sp.value && this.sp.value.minimum_age_for_main_guest;
                    return v === null || v === undefined ? '' : String(v);
                },
                set(val) {
                    const num = parseInt(val, 10);
                    this.$set(this.sp.value, 'minimum_age_for_main_guest', isNaN(num) ? null : num);
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/RulesTab.vue